import { gql } from '@apollo/client'

export const MERGE_CUSTOMERS_MUTATION = gql`
  mutation mergeCustomers($id: ID!, $mergeIds: [ID!]!) {
    mergeCustomers(id: $id, mergeIds: $mergeIds)
  }
`
